import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useTranslation } from "react-i18next";

type DynamicRecordDrawerFooterProps = {
  isDeleting?: boolean;
  isSubmitting?: boolean;
  mode?: "add" | "edit";
  onCancel: () => void;
  onDelete?: () => void;
  onDeleteLabel?: string;
  onSave: () => void;
};

export const DynamicRecordDrawerFooter = ({
  isDeleting,
  isSubmitting,
  mode = "edit",
  onCancel,
  onDelete,
  onDeleteLabel,
  onSave,
}: DynamicRecordDrawerFooterProps) => {
  const { t } = useTranslation();

  return (
    <Stack className="flex justify-between gap-3 border-t border-lds-border-subtle px-6 py-4">
      {onDelete ? (
        <Button isLoading={isDeleting} onClick={onDelete} size="md" variant="error">
          {onDeleteLabel ?? t("general.delete")}
        </Button>
      ) : (
        <span />
      )}
      <Stack className="flex justify-end gap-3">
        <Button onClick={onCancel} size="md" variant="secondary">
          {t("general.cancel")}
        </Button>
        <Button isLoading={isSubmitting} onClick={onSave} size="md" variant="success">
          {mode === "add" ? t("general.submit") : t("general.save")}
        </Button>
      </Stack>
    </Stack>
  );
};
